<template>
  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >
        <div class="d-flex mb-5">
          <v-btn color="primary" text href="./Инструкция.pdf" download>Скачать инструкцию</v-btn>
          <v-spacer/>
          <v-btn color="primary" text href="./Қўлланма.pdf" download>Qo'llanmani yuklab olish</v-btn>
        </div>

        <LoginComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {AUTH_SUCCESS} from "@/events/auth";
import LoginComponent from '../../components/LoginComponent'
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "LoginPage",
  components: {
    LoginComponent
  },
  methods: {
    onAuthSuccess() {
      this.$router.push({name: 'dashboard'})
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Логин')
    this.$bus.$on(AUTH_SUCCESS, this.onAuthSuccess)

    if (this.$store.getters.isTokenOk)
      this.$router.push({name: 'dashboard'})
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_SUCCESS, this.onAuthSuccess)
  }
}
</script>

<style scoped>

</style>